import { VERIFY_PAYMENT_RESULT } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case VERIFY_PAYMENT_RESULT:
      return { ...state, is_valid: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/PaymentVerification.js